import { createContext, useContext } from "react";
//#region src/components/AppShell/AppShellContext.ts
var AppShellContext = createContext(null);
/** The surrounding AppShell's state, or null outside one. */
function useAppShell() {
	return useContext(AppShellContext);
}
//#endregion
export { AppShellContext, useAppShell };

//# sourceMappingURL=AppShellContext.js.map